import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { nl } from "./nl";

// Bundled rather than fetched, so `t` answers on the first render.
void i18n.use(initReactI18next).init({
  resources: { nl },
  lng: "nl",
  fallbackLng: "nl",
  defaultNS: "common",
  // React already escapes what it renders.
  interpolation: { escapeValue: false },
});

export default i18n;
